import styled from 'styled-components'

export const Divider = styled.hr`
border: none;
border-bottom: 0.935252px solid #babaca;
margin: 0 0 20px 0;
width: 100%;
`
